var _rect, _rect2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRent(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 306,
    height: 313,
    viewBox: "0 0 306 313",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 5,
    width: 296,
    height: 303,
    rx: 30,
    stroke: "#828282",
    strokeOpacity: 0.6,
    strokeWidth: 10
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 51,
    y: 62,
    width: 200,
    height: 200,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_3827_70",
    transform: "scale(0.01)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_3827_70",
    width: 100,
    height: 100,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAYAAABw4pVUAAAACXBIWXMAAAsTAAALEwEAmpwYAAADaklEQVR4nO2az2rVQBSHh0JRUASXig8gqEt15cYHsFBdFgplzm/uvZJnCLqoy+rOru2+mz6CC19ArO4UwWWRCuqmlWDFdLjJTW4yycnk98HApfkzk/nmZCZnagwhhBBCCCGEKAHAKQuC9QGFQNcAoxD0L4FCELGQANPUqACF6IJClEEhyqAQZVCIMihEGRSiDApRBoUog0KUQSHKGJUQa+2trBjFjEZImqYrIvIWwLvst1HKaIQAePqvjSIyM0oZhZCtra3rAI5yQr5ba28YhYxCCID9OZs/B0Yh0QsRkcclO3LrRhlRC0mS5IqIfC0SIiLfptPpVaOIqIWIyK7Xvt9nJS9l1ygiWiHW2gcATrz2PQPw3PvbibX2oVFClEKSJLkgIu+9tn3c3Ny8WHbMKCBKIVgQBUXRYxQQnRAAN0Xkl9eu11XmFw1plaiEpP/TIwtXUgUrsN7TKlEJQS49UuVbY943St9plWiEALiWT49U/Rr3v+L7TqvEJGR/mY5dVmQoohAiDV89dV91IRm8kKSFybnOYiA0gxciLS1fqy6XQzNoIbblDzwNaZXBCkkCpEA0pFUGKwSBRnPfaZVBCkHg932faZXBCeliRZT0mFZpXUhPZb3jrd/OyhCFHLQtY8E/R1BIUSdI4LxTQVqFQkqEzExgsjoGJaSIYDeOBHTdPxRSDoUog0KUQSHKoBBlUIgyKEQZ6oR08cEEYNU59wTAHoAPAH6IyPHZ772zY6vLPE/T9o5OiHNuTUQ+LbpPdk52bt3noZCKQtI0XQHwomaHZRtS22XpdQpZMkJQX0a+bFNIxVdQFSHOubU5268/RWTHOXdvY2PjUlay3wBeZsf8SBGRR8vWX+d89XNIC/dbnTNnfJ5MJrdL7nlHRL74c8q8iZ5CanaI+7tiOhcZZTI8Kef257N7UUjzCNnzRvrOonvmrn3lXfuGQhoKEZFDr1Pv1hBy37v2kEKaCznOH5/NZperCsnO9YQcU0jPqxZ0vwiJfpV1SiEUUggjBIyQVkdI3WJq1hdbe03sD4iBtdfE/oAYWHtN7A+IgbW3Nl1XiMBC2oZCFkAhLQNGSFwjDgNrr/oKQSEU0gRGSGQRrb5C8JVFIU1ghEQW0Y0rZEGt1AqFoN9BQyHQFbUUgpEJIYQQQgghhBDTjD/eKn5xOzLrlQAAAABJRU5ErkJggg=="
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRent);
export default __webpack_public_path__ + "static/media/Rent.2cfa67665a159288ff2e6ef100627633.svg";
export { ForwardRef as ReactComponent };